export interface TurnosRetiroEccomerce {
    agendado: number,
    dia: number,
    fecha: string,
    horafin: number,
    horainicio: number,
    limiteentrega: number,
    modo: number,
    sucursal: number,
}